import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Avatar,
  Paper
} from "@mui/material";

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box>
      {/* Hero Section con video o imagen de fondo */}
      <Box sx={{ position: "relative", minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <video
          src="https://netofcomputers.com/media/bjam/bg_I.mp4"
          autoPlay
          loop
          muted
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
          }}
        />
        <Box sx={{ position: "relative", color: "white", textAlign: "center", p: 4, zIndex: 1 }}>
          <Typography variant="h2" fontWeight="bold" gutterBottom>
            Bienvenidos a bjam
          </Typography>
          <Typography variant="h6" sx={{ maxWidth: 600, mb: 4 }}>
            Un espacio creativo donde las ideas fluyen, los amigos hacen jam, y las vibras se hacen realidad. 🎧
          </Typography>
          <Button variant="contained" color="primary" size="large" onClick={() => navigate("/bjam/linkpost")}>
            Accede al Portal de Jam
          </Button>
        </Box>
      </Box>

      {/* SECCIÓN DE NOTICIA: YOUTUBE JAMS (Tema Oscuro) */}
      <Container sx={{ py: 4 }}>
        <Paper
          elevation={5}
          sx={{
            p: 4,
            textAlign: "center",
            backgroundColor: '#1e1e1e', // Fondo oscuro (casi negro)
            color: '#ffffff', // Letra blanca
            borderLeft: '5px solid #ff4081', // Barra rosa brillante
            borderRadius: 2
          }}
        >
          <Typography variant="h5" color="#ff4081" gutterBottom fontWeight="bold">
            😍 ¡Por fin tenemos de vuelta las YoutubeJams! 🦍
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            ¡La función más esperada está de regreso y mejorada! Ahora puedes añadir videos de YouTube con **opciones avanzadas** como el modo pantalla completa, apagado automático del PC y límite de reproducciones. ¡A disfrutar!
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate("/bjam/linkpost")}
            sx={{ backgroundColor: '#ff4081', '&:hover': { backgroundColor: '#f50057' } }} // Botón rosa
          >
            Haz click aquí para subir videos
          </Button>
        </Paper>
      </Container>
      {/* FIN SECCIÓN DE NOTICIA */}
      {/* Sección de Galería de Imágenes y Videos */}
      <Container sx={{ py: 8 }}>
        <Typography variant="h4" gutterBottom textAlign="center">
          Descubre Nuestro Espacio Creativo
        </Typography>
        <Grid container spacing={4}>
          {/* Foto 1 */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardMedia
                component="img"
                height="200"
                image="https://netofcomputers.com/media/bjam/studio.jpeg" // Aquí reemplaza con la URL de tu foto o video
                alt="Estudio creativo"
              />
              <CardContent>
                <Typography variant="h6">Nuestro Estudio</Typography>
                <Typography variant="body2" color="text.secondary">
                  Un vistazo a nuestro estudio, donde las ideas y la creatividad se fusionan.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Foto 2 */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardMedia
                component="img"
                height="200"
                image="https://netofcomputers.com/media/bjam/team.jpeg" // Reemplazar con tu contenido
                alt="Jam de amigos"
              />
              <CardContent>
                <Typography variant="h6">Amigos Jammin'</Typography>
                <Typography variant="body2" color="text.secondary">
                  Momentos únicos con amigos en sesiones de jam y creatividad desbordante.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Video instead of image */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <Box sx={{ position: "relative", height: 200 }}>
                <video
                  src="https://netofcomputers.com/media/bjam/main_view.mp4"
                  autoPlay
                  loop
                  muted
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
              <CardContent>
                <Typography variant="h6">Nuestro Equipo</Typography>
                <Typography variant="body2" color="text.secondary">
                  Un equipo dedicado a hacer que cada experiencia musical sea única.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

        </Grid>
      </Container>

      {/* Testimonios */}
      <Container sx={{ py: 8, backgroundColor: "#f7f7f7" }}>
        <Typography variant="h4" gutterBottom textAlign="center">
          Lo que dicen nuestros visitantes
        </Typography>





        <Grid container spacing={4}>



          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ height: "100%" }}>
              <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {/* Imagen de perfil */}
                <Avatar
                  alt="Juan Pérez"
                  src="https://netofcomputers.com/media/bjam/edu.jpeg" // Reemplazar con la URL de la imagen de perfil
                  sx={{ width: 100, height: 100, mb: 2 }} // Tamaño de la imagen
                />
                <Typography variant="h6" align="center">
                  El mejor lugar para crear música
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center">
                  Tuve la oportunidad de grabar mi primer EP aquí, y fue una experiencia increíble. El equipo y el ambiente son de otro nivel.
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ fontStyle: "italic" }}>
                  - Edwardio, Músico
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ height: "100%" }}>
              <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {/* Imagen de perfil */}
                <Avatar
                  alt="Juan Pérez"
                  src="https://netofcomputers.com/media/bjam/jorge.png" // Reemplazar con la URL de la imagen de perfil
                  sx={{ width: 100, height: 100, mb: 2 }} // Tamaño de la imagen
                />
                <Typography variant="h6" align="center">
                  Mi lugar favorito para grabar

                </Typography>
                <Typography variant="body2" color="text.secondary" align="center">
                  Desde el primer momento, el equipo de bjam me hizo sentir como en casa. La calidad del equipo de grabación y el ambiente son de primera. Logré capturar el sonido perfecto para mi proyecto gracias a su apoyo.
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ fontStyle: "italic" }}>
                  - Jorge, G&R
                </Typography>
              </CardContent>
            </Card>
          </Grid>


          <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ height: "100%" }}>
              <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {/* Imagen de perfil */}
                <Avatar
                  alt="Juan Pérez"
                  src="https://netofcomputers.com/media/bjam/lmedin.png" // Reemplazar con la URL de la imagen de perfil
                  sx={{ width: 100, height: 100, mb: 2 }} // Tamaño de la imagen
                />
                <Typography variant="h6" align="center">
                  Muchas ganas de volver
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center">
                  Siempre me he sentido inspirado cada vez que vengo a bjam. El ambiente, el equipo, y las herramientas disponibles hacen que todo fluya naturalmente. ¡Unicamente necesitaría más delay!
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ fontStyle: "italic" }}>
                  - LUIS MADE IN , Teacher
                </Typography>

              </CardContent>
            </Card>
          </Grid>

        </Grid>
      </Container>

      {/* Llamada a la acción */}
      <Box sx={{ py: 6, textAlign: "center", backgroundColor: "#282828" }}>
        <Typography variant="h5" color="white" gutterBottom>
          ¿Estás listo para unirte a la experiencia bjam?
        </Typography>
        <Button variant="contained" color="primary" size="large" onClick={() => navigate("/bjam/contacto")}>
          Contáctanos
        </Button>
      </Box>
    </Box>
  );
};

export default Home;
